import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'ghost';
    children: React.ReactNode;
    as?: 'button' | 'span';
}

export function Button({ variant = 'primary', children, className = '', as = 'button', ...props }: ButtonProps) {
    const baseClass = 'btn';
    const variantClass = `btn-${variant}`;
    const Component = as;

    return (
        <Component
            className={`${baseClass} ${variantClass} ${className}`}
            {...(as === 'button' ? props : {})}
        >
            {children}
        </Component>
    );
}
